module.exports = __webpack_public_path__ + "img/receipt_bg_top.ac961b33.svg";